(function () {

  const menuOpen = document.getElementById('hamburger-button');
  const menuClose = document.getElementById('hamburger-close');
  const menu = document.getElementById('footer');
  const menuLinks = menu.querySelectorAll('a');

  menuOpen.addEventListener('click', function() {
    menu.classList.toggle('show');
    if (menu.classList.contains('show')) {
      menuLinks[0].focus();
    }
  });
  menuClose.addEventListener('click', function() {
    if (menu.classList.contains('show')){
      menu.classList.remove('show');
    }
  });
  menu.addEventListener('blur', function() {
    menu.classList.remove('show');
    document.body.classList.remove('menu-open');
  });

})();
